import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { NavParams, AlertController, ModalController, IonContent, IonInfiniteScroll } from '@ionic/angular';
import { PtyLdService } from 'src/app/services/pty-ld.service';
import { PtyWsService } from 'src/app/services/pty-ws.service';
import { TranslationService } from "../../services/translation.service";
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-seeker-request-copilot-demo',
    templateUrl: './seeker-request-copilot-demo.component.html',
    styleUrls: ['./seeker-request-copilot-demo.component.scss'],
})
export class SeekerRequestCopilotDemoComponent implements OnInit {

    userTemplates: any = [];
    public show: boolean = false;

    copilotData: any = {};

    clickedIndex: number = null;    // old: elemntindex

    isLoadMoreRunning: boolean = false;
    isPageCurrentlyLoaded: boolean = true;

    @ViewChild(IonContent, { static: true }) content: IonContent;
    @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
    @Input() messages: any[] = [];
    @Input() languageCode: string = 'eng';

    constructor(
        private navParams: NavParams,
        private alertCtrl: AlertController,
        private ld: PtyLdService,
        private ws: PtyWsService,
        private modalCtrl: ModalController,
        private _translationService: TranslationService
    ) {
        this.userTemplates = this.navParams.get('templates');

    }

    ngOnInit() {
        this.loadSuggestions();
    }

    ionViewWillEnter() {
        this.isPageCurrentlyLoaded = true;
        this.isLoadMoreRunning = false;
    }

    ionViewWillLeave() {
        this.isPageCurrentlyLoaded = false;
    }

    loadSuggestions() {
        const self = this;
        self.ld.showLoading(true, { message: 'Fetching suggested responses. Please wait, this can be very slow...', duration: 600000 }).then(() => {
            const messages = this.messages.map(msg => {
                return {
                    content: msg.msg_body && msg.msg_body.body && msg.msg_body.body.text !== '' ? msg.msg_body.body.text : msg.msg_text,
                    type: msg.user_type === 'O' ? 'OM' : 'Contact',
                };
            })
            // tslint:disable-next-line: max-line-length
            self.ws.invokeURL('copilot-demo', {
                payload: {
                    language: this.languageCode,
                    messages,
                }
            }, 300000).subscribe((response: any) => {
                if (response.error !== 0) {
                    self.ld.showLoading(false, {message: 'Unexpected error fetching data from Copilot AI'});
                    return;
                }

                // Strip HTML
                if (response.copilotData && response.copilotData.references && response.copilotData.references.length > 0) {
                    response.copilotData.references = response.copilotData.references.map(ref => {
                        // Remove HTML tags
                        ref.content = ref.content
                            .replace('/<\/p>', "\n")
                            .replace('/<br\s*\/>', "\n")
                        ;

                        ref.content = ref.content.replace(/<[^>]+>/g, ' ');

                        // Replace some markdown
                        ref.content = ref.content.replace(/#+ /g, '');
                        return ref;
                    });

                }

                this.copilotData = response.copilotData;

                //Load Templates again after saving changes
                // self.loadUserTemplates();
                self.ld.showLoading(false);

            }, (err: any) => {
                console.error('Error getting copilot response', err);
                self.ld.showLoading(false, { message: this._translationService.translate('UnknownError') });
            });
        });
    }

    scrollToTop() {
        this.content.scrollToTop(1500);
    }

    dismiss(type: string, index: number = null) {
        if (type !== 'response' && type !== 'resource') {
            this.modalCtrl.dismiss({ dismissed: true, type: 'none', content: '' });
            return;
        }
        if (type === 'response') {
            this.modalCtrl.dismiss({ dismissed: true, type, content: this.copilotData.suggestion });
            return;
        }
        if (type === 'resource') {
            this.modalCtrl.dismiss({ dismissed: true, type, content: this.copilotData.references[index].content });
            return;
        }
    }
    async showResource(index: any) {
        this.clickedIndex = index;
    }
}
